import { useEffect } from "react";

export const opsHead = (title: string) => ({
  meta: [{ title: `${title} - Primary Ops` }],
});

export function useOpsTitle(title: string | undefined) {
  useEffect(() => {
    if (title) {
      document.title = `${title} - Primary Ops`;
    }
  }, [title]);
}
